import { format, add, sub, getDay, getMonth, getDate, getYear } from "date-fns";
export const idGenerator = () => {
  return Math.floor(Math.random() * 100000);
};

export const timeSince = (days) => {
  let calcDate = new Date(Date.now() - days * 24 * 3600 * 1000);
  let seconds = Math.floor((new Date() - calcDate) / 1000);

  let interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + "y ago";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + "m ago";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + "d ago";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + "h ago";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + "m ago";
  }
  return Math.floor(seconds) + "s ago";
};

export const parseGradientArray = (gradientArray) => {
  const gradients = [];
  let percentageDefined = 0;
  let undefinedGradientCounts = 0;

  for (let count = 0; count < gradientArray.length; count++) {
    const gradientValues = gradientArray[count].trim().split(" ");

    if (gradientValues.length === 1) {
      gradients.push({ color: gradientValues[0], percent: -1 });
      undefinedGradientCounts++;
    } else {
      const percent = parseInt(
        gradientValues[gradientValues.length - 1].trim(),
      );
      gradients.push({ color: gradientValues[0], percent: percent });
      percentageDefined += percent;
    }
  }

  if (undefinedGradientCounts) {
    const equalPercent = (100 - percentageDefined) / undefinedGradientCounts;
    for (let count = 0; count < gradients.length; count++) {
      if (gradients[count].percent === -1) {
        gradients[count].percent = equalPercent;
      }
    }
  }
  return gradients;
};

export const getDateElements = (date) => {
  const inputDate = new Date(date);

  const day = format(inputDate, "eeee"); // eeee will give full name like "Monday"
  const time = format(inputDate, "hh:mm a");
  const month = format(inputDate, "MMMM"); // Full month name
  const dateNum = format(inputDate, "dd"); // Two digit date
  const year = format(inputDate, "yyyy"); // Four digit year

  return {
    day,
    time,
    date: {
      dateString: `${month} ${dateNum} ${year}`,
      month,
      date: dateNum,
      year,
    },
  };
};

/**
 * Get Custom Date Time
 * @param value
 * @param unit
 * @param format
 * @returns {string}
 */

export const getCustomDateTime = (
  value = 0,
  unit = "days",
  formatStr = "HH:mm a | MMMM dd, yyyy",
) => {
  let date = new Date();
  if (value !== 0) {
    date =
      unit === "days"
        ? add(date, { days: value })
        : unit === "hours"
        ? add(date, { hours: value })
        : unit === "minutes"
        ? add(date, { minutes: value })
        : date; // Add other units as needed
  }
  return format(date, formatStr);
};

export const getCustomDate = (
  value = 0,
  unit = "days",
  formatStr = "HH:mm, dd MMMM",
) => {
  if (value === 0) {
    return "Today";
  }
  if (value === 1) {
    return "Yesterday";
  }
  let date = sub(new Date(), { [unit]: value });
  return format(date, formatStr);
};

export const getCustomTime = (
  value = 0,
  unit = "minutes",
  formatStr = "hh:mm a",
) => {
  let date = new Date();
  if (value !== 0) {
    date =
      unit === "days"
        ? sub(date, { days: value })
        : unit === "hours"
        ? sub(date, { hours: value })
        : unit === "minutes"
        ? sub(date, { minutes: value })
        : date; // Subtract other units as needed
  }
  return format(date, formatStr);
};

export const getYesterdayDate = () => {
  const yesterday = sub(new Date(), { days: 1 });
  return format(yesterday, "dd.MM.yyyy");
};
export const capitalizeFLetter = (string) => {
  return string[0].toUpperCase() + string.slice(1);
};

export const isValidEmail = (emailAddress) => {
  const pattern = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
  );
  return pattern.test(emailAddress);
};

export const formatTimestamp = (timestamp) => {
  if (!timestamp) return "";

  const date = new Date(timestamp);
  const now = new Date();
  const diffInHours = (now - date) / (1000 * 60 * 60);

  // If less than 24 hours, show relative time
  if (diffInHours < 24) {
    if (diffInHours < 1) {
      const diffInMinutes = Math.floor((now - date) / (1000 * 60));
      if (diffInMinutes < 1) {
        return "Just now";
      }
      return `${diffInMinutes} minute${diffInMinutes > 1 ? "s" : ""} ago`;
    }
    return `${Math.floor(diffInHours)} hour${
      Math.floor(diffInHours) > 1 ? "s" : ""
    } ago`;
  }

  // If more than 24 hours, show date and time
  return (
    date.toLocaleDateString() +
    " " +
    date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
  );
};
